export const ResidenceExplorerServiceEndpoints = {
    getData: (stageId: string) =>  `/residenceexplorer/get/${stageId}`,
    getExternalData: (stageId: string) =>  `/residenceexplorer/getExternalLinker/${stageId}`,
}


export const ResidenceExplorerServicQueryKeys = {
    getExternalData: (stageId: string) => ['exernalExplorerBlock', stageId],
}
